<template>
    <div v-if="can('schedules.create')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/transportation-organization" tag="li" class="breadcrumb-item"><a href="">{{i18n('Transportation organization')}}</a></router-link>
                <router-link to="/schedules" tag="li" class="breadcrumb-item"><a href="">{{i18n('Flights schedule')}}</a></router-link>
                <router-link to="/schedule-new" tag="li" class="breadcrumb-item"><a href="">{{i18n('Create')}}</a></router-link>
            </ol>
        </nav>

        <form action="" @submit.prevent="save()" @change="form.errors.clear($event.target.name)">
            <div class="base_box_hdr">
                <div class="base_box_ttl">
                    <h1 class="title">{{i18n('Schedule Flights (Creation)')}}</h1>
                    <div v-if="is_loading">
                        {{i18n('Loading data')}}...
                    </div>
                </div>
                <div class="base_box_cnt">
                    <div class="row">
                        <div class="col-xl-8 col-sm-12 col-12">
                            <div class="button-group">
                                <button type="button" @click="save(true)" :disabled="is_sending" class="btn base_btn solid_blue waves-effect waves-light">{{i18n('Save and close')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="base_box_cnt pb-0">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class="form-row">
                            <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n('Routes')}}:</label>
                            <div class="form-group col-sm-9">
                                <select-picker-new
                                               :form="form"
                                               :disabled="routes.length === 0  ? 'disabled' : false"
                                               :field="'route_id'"
                                               :items="routes"
                                               :value="'id'"
                                               :text="'name'"
                                               :prompt="i18n('Choose a route')"
                                               :filterable="true"
                                               @change="handleRouteChange"
                                >
                                </select-picker-new>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-row">
                            <label class="col-sm-3 col-form-label fs-12 pt-12">{{i18n('Trip number')}}:</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control base_input" disabled v-model="form.number"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="base_box_main">
                <div class="base_box_cnt gray_box mb-3">
                    <div class="row">
                        <div class="col-lg-3 col-sm-4">
                            <p>{{i18n('Departure')}}: <span class="timeStart boldText">{{departureTime | moment('HH:mm')}}</span></p>
                        </div>
                        <div class="col-lg-3 col-sm-4">
                            <p>{{i18n('Arrival')}}: <span class="timeEnd boldText">{{arrivalTime | moment('HH:mm')}}</span></p>
                        </div>
                        <div class="col-lg-6 col-sm-4">
                            <p>в пути: <span class="boldText">{{timeOnWay | asTime(i18n)}}</span></p>
                        </div>
                    </div>
                </div>
                <nav>
                    <div class="nav nav-tabs" id="nav-tab01" role="tablist">
                        <a class="nav-item nav-link active" id="nav-01-tab01" data-toggle="tab" href="#nav-01-1" role="tab" aria-controls="nav-01-1" aria-selected="true">{{i18n('Basic')}}</a>
                        <a class="nav-item nav-link" id="nav-02-tab01" data-toggle="tab" href="#nav-02-1" role="tab" aria-controls="nav-02-1" aria-selected="false">{{i18n('Bus terminals')}}</a>
                        <a class="nav-item nav-link" id="nav-03-tab01" data-toggle="tab" href="#nav-03-1" role="tab" aria-controls="nav-03-1" aria-selected="true">{{i18n('Price entry')}}</a>
                        <a class="nav-item nav-link" id="nav-04-tab01" data-toggle="tab" href="#nav-04-1" role="tab" aria-controls="nav-04-1" aria-selected="true">{{i18n('Baggage')}}</a>
                    </div>
                </nav>
                <div class="tab-content" id="nav-tabContent01">
                    <div class="tab-pane fade show active" id="nav-01-1" role="tabpanel" aria-labelledby="nav-01-tab">
                        <schedule-main
                            :form="form"
                            :isUpdate="isUpdate"
                            :generatedFor="generated_for"
                        ></schedule-main>
                    </div>
                    <div class="tab-pane fade" id="nav-02-1" role="tabpanel" aria-labelledby="nav-02-tab">
                        <set-times
                            :form="form"
                            :isUpdate="isUpdate"
                            :stations="stations"
                            :all-stations="allStations"
                            @timesChanged="handleTimesChanged"
                            @unsetStation="unsetStation"
                        ></set-times>
                    </div>
                    <div class="tab-pane fade" id="nav-03-1" role="tabpanel" aria-labelledby="nav-03-tab">
                        <set-prices
                            :form="form"
                            :isUpdate="isUpdate"
                            :stations="stations"
                            :prices="schedule_trip_prices"
                            :tariffs="tariffs"
                            @tariffChanged="calculatePrices"
                        ></set-prices>
                    </div>
                    <div class="tab-pane fade" id="nav-04-1" role="tabpanel" aria-labelledby="nav-04-tab">
                        <set-baggage-prices
                            :form="form"
                            :isUpdate="isUpdate"
                            :routeDetails="stations"
                            :prices="schedule_trip_baggage_prices"
                            :baggage_services="baggage_services"
                            :baggageServiceExist="isBaggageServiceSelected()"
                            @baggageServiceChanged="calculateBaggagePrices"
                        ></set-baggage-prices>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import ScheduleMain from "./components/ScheduleMain";
    import SetTimes from "./components/SetTimes";
    import SetPrices from "./components/SetPrices";
    import SetBaggagePrices from "./components/SetBaggagePrices";
    import FormService from "../../services/FormService";
    import SelectPicker from '../../components/SelectPicker';
    import SelectPickerNew from '../../components/SelectPickerNew';

    export default {
        name: "ScheduleNew",
        components: {SetPrices, SetTimes, ScheduleMain, SelectPicker, SelectPickerNew, SetBaggagePrices},
        data() {
            return {
                is_loading: false,
                id: null,
                form: new FormService({
                    id: null,
                    route_id: null,
                    number: '',
                    trip_regularity_type: 1,
                    begin_at: this.$moment().format('Y-MM-DD'),
                    finish_at: null,
                    transporter_id: null,
                    bus_id: null,
                    tariff_id: null,
                    baggage_service_id: null,
                    driver_id: '',
                    days: [],
                    schedule_trip_details: [],
                    schedule_trip_prices: {},
                    schedule_trip_baggage_prices: {},
                    comment: '',
                    payment_calculation_type: 1,
                    baggage_price_calculation_type: 1,
                    max_baggage_allowance: 0,
                    free_baggage_allowance: 0,
                    price: 0,
                    reserved_minutes: null,
                    reserved_seats: null,
                    generate_to_finish: false
                }),
                routes: [],
                allStations: [],
                stations: [],
                stationIds: [],
                tariffs: [],
                baggage_services: [],
                schedule_trip_prices: [],
                schedule_trip_baggage_prices: [],
                schedule_trip_prices_update: [],
                schedule_trip_baggage_prices_update: [],
                baggageServiceExist: false,
                currentRoute: {},
                arrivalTimes: [],
                departureTimes: [],
                isUpdate: false,
                generated_for: null,
                is_sending: false,
                baggageServicePricingTypes: {
                    TYPE_FIXED_PRICE: 1,
                    TYPE_PER_KM_PRICE: 2,
                    TYPE_PERCENT_PRICE: 3,
                }
            }
        },
        created() {
            console.log(this.begin_at);
            Object.freeze(this.baggageServicePricingTypes);
            this.is_loading = true;
            this.getAllRoutes().then(res => {
                this.getTariffs();
                this.getBaggageServices();
                //this.id = parseInt(this.$route.params.id);
                //if (this.id) {
                //    this.getSchedule();
                //}
            });
        },
        methods: {
            async getSchedule() {
                await this.$api.get('schedule-trips.show', this.id)
                    .then(res => {
                        let data = res.data;
                        let form = this.form;

                        form.id = this.id;
                        form.route_id = data.route.id;
                        form.tariff_id = data.tariff_id;
                        form.baggage_service_id = data.baggage_service_id;
                        form.number = data.route.number;
                        form.trip_regularity_type = data.trip_regularity_type;
                        form.days = data.days;
                        form.begin_at = data.begin_at;
                        form.finish_at = data.finish_at;
                        if (data.bus_id) {
                            form.transporter_id = data.bus.transporter_id;
                            form.bus_id = data.bus_id;
                            form.driver_id = data.bus.driver_id;
                            this.driver = data.bus.driver.name;
                        }
                        form.is_international = data.is_international;
                        form.schedule_trip_details = data.schedule_trip_details;
                        form.comment = data.comment;
                        form.payment_calculation_type = data.payment_calculation_type;
                        form.baggage_price_calculation_type = data.baggage_price_calculation_type;
                        form.free_baggage_allowance = data.free_baggage_allowance;
                        form.max_baggage_allowance = data.max_baggage_allowance;
                        form.reserved_seats = JSON.parse(data.reserved_seats);
                        form.reserved_minutes = data.reserved_minutes;
                        this.schedule_trip_prices_update = JSON.parse(data.prices.price);
                        if (!_.isEmpty(data.baggage_prices)) {
                            this.schedule_trip_baggage_prices_update = JSON.parse(data.baggage_prices.price);
                        } else {
                            this.schedule_trip_baggage_prices_update = {from: 0, to: 0, price: 0}
                        }

                        if (data.generated_for) {
                            this.generated_for = this.$moment(data.generated_for).add(1, 'days').format('Y-MM-DD H:mm');
                        }

                        // setTimeout(() => {
                            this.handleRouteChange();
                            this.isUpdate = true;
                        // }, 2000);
                    })
            },
            setStations(route) {
                route.routes_stations.forEach(item => {
                    let exist = this.form.schedule_trip_details.findIndex(it => it.routes_station_id === item.id);
                    if (exist >= 0) {
                        this.stations.push(item);
                    }
                });
            },
            async getTariffs() {
                await this.$api.get('tariff.all')
                    .then(res => {
                        this.tariffs = res.data;
                    });
            },
            async getBaggageServices() {
                await this.$api.get('baggage.index')
                    .then(res => {
                        this.baggage_services = res.data;
//alx
this.id = parseInt(this.$route.params.id);
if (this.id) {
    this.getSchedule();
}
                    });
            },
            async getAllRoutes() {
                await this.$api.get('routes.all')
                    .then(res => {
                        this.routes = res.data;
                        this.is_loading = false;
                    });
            },
            getSelectedRoute(){
                return this.routes.find(route => route.id === this.form.route_id);
            },
            handleRouteChange() {
                // console.log('routes', this.routes);
                // don't replace with this.getSelectedRoute() function, there are strange errors. I think they are related with script execution time
                let route = this.routes.find(route => route.id === this.form.route_id);
                this.form.number = route ? route.number : '';
                this.allStations = route ? route.routes_stations : [];
                if (this.id > 0) {
                    this.setStations(route);
                    this.stationIds = this.stations.map(item => item.id);
                } else {
                    this.stations = this.allStations;
                    this.stationIds = this.allStations.map(item => item.id);
                }
                this.calculatePrices();
                if (!_.isEmpty(this.schedule_trip_baggage_prices_update) && this.isBaggageServiceSelected()) {
                    this.calculateBaggagePrices();
                }
            },
            calculatePrices() {
                //
                let tariff = this.tariffs.find(item => item.id === this.form.tariff_id);

                let t_price = tariff ? parseInt(tariff.price_per_km) : 0;

                let per_price;
                for (let i = 0; i < this.stations.length; i++) {

                    per_price = 0;
                    if (i < this.stations.length - 1) {
                        this.schedule_trip_prices[i] = [];
                        for (let j = 0; j < this.stations.length; j++) {
                            if (j > i) {
                                if (this.form.payment_calculation_type === 2) {
                                    let exist_price = this.schedule_trip_prices_update.find(price =>
                                        price.from === this.stations[i].station_id
                                        && price.to === this.stations[j].station_id
                                    );
                                    this.schedule_trip_prices[i][j] = exist_price ? parseInt(exist_price.price) : 0;
                                } else {
                                    per_price += parseInt(this.stations[j].distance) * t_price;
                                    this.schedule_trip_prices[i][j] = per_price;
                                }
                            }
                        }
                    }
                }
                this.$forceUpdate();
            },
            /*
            * this.stations -> RouteDetails
            * this.schedule_trip_baggage_prices array of prices for render
            *               -> [
            *                      [undefined, 700som, 650som, 600som],
            *                      [undefined, undefined, 400som, 650som],
            *                   ]
            * baggService.baggage_service_options array of prices per km
            *               -> [
            *                      {distance: 20, price_before_distance: 700}
            *                      {distance: 40, price_before_distance: 650}
            *                   ]
            * */
            calculateBaggagePrices() {
                if (/*!this.isTariffSelected() ||*/ !this.isBaggageServiceSelected()) {
                    return;
                }
                let baggageService = this.getBaggageService();
//alx
if (!baggageService) {
    return;
}

                if (this.form.baggage_price_calculation_type === 1) {
                    this.setBaggageAllowanceFromBaggageService(baggageService);
                }

                for (let row = 0; row < this.stations.length; row++) {

                    if (row >= this.stations.length - 1) {
                        continue;
                    }
                    this.schedule_trip_baggage_prices[row] = [];
                    for (let col = 0; col < this.stations.length; col++) {
                        if (col > row) {
                            if (this.form.baggage_price_calculation_type === 2) {
                                let exist_price = this.schedule_trip_baggage_prices_update.find(price =>
                                        price.from === this.stations[row].station_id
                                        && price.to === this.stations[col].station_id
                                );
                                this.schedule_trip_baggage_prices[row][col] = exist_price ? parseInt(exist_price.price) : 0;
                            } else {
                                // Matrix (schedule_trip_baggage_prices) — a two-dimensional array of prices, which will be used to render the price table
                                // Intersection — the current pair of stations in the `matrix` for which the distance and the amount are calculated
                                let intersectionPrice = 0;
                                switch (baggageService.pricing_type) {
                                    case this.baggageServicePricingTypes.TYPE_FIXED_PRICE:
                                        intersectionPrice = baggageService.default_price_for_step;
                                        break;
                                    case this.baggageServicePricingTypes.TYPE_PERCENT_PRICE:
                                        intersectionPrice =
                                                (this.schedule_trip_prices[row][col] / 100) * baggageService.percent;
                                        break;
                                    case this.baggageServicePricingTypes.TYPE_PER_KM_PRICE:
                                        let currentIntersection = {row: this.stations[row], col: this.stations[col]};
                                        let distance = this.getDistance(currentIntersection);
                                        intersectionPrice = this.getBaggagePrice(distance);
                                        break;
                                }
                                this.schedule_trip_baggage_prices[row][col] = intersectionPrice;
                            }
                        }
                    }
                }
                this.$forceUpdate();
            },
            getDistance(intersection) {
                let routeDetails = _.sortBy(this.stations, routeDetail => routeDetail.order);
                routeDetails = routeDetails.filter(routeDetail => {
                    return intersection.row.order < routeDetail.order &&
                            intersection.col.order >= routeDetail.order
                });
                return _.sumBy(routeDetails, routeDetail => +routeDetail.distance);
            },
            getBaggagePrice(intersectionDistance) {
                let baggageService = this.getBaggageService();
                let serviceOptions = baggageService.baggage_service_options;
                // TODO clarify that should I add `order` column for `baggage_service_options` table and sort by this column
                let maximumMarkedDistance = _.last(_.sortBy(serviceOptions, option => option.id)).distance;

                serviceOptions = serviceOptions.filter((opt, idx, arr) => {
                    let prevOptDistance = !_.isEmpty(arr[idx-1]) ? arr[idx-1].distance : 0;
                    return opt.distance <= intersectionDistance ||
                            (prevOptDistance < intersectionDistance && opt.distance > intersectionDistance);
                });
                let intersectionPrice = _.sumBy(serviceOptions, opt => opt.price_before_distance);

                if (intersectionDistance > maximumMarkedDistance) {
                    const distanceOverMarkedLimit = intersectionDistance - maximumMarkedDistance;
                    const stepsOverMarkedLimit = Math.ceil(distanceOverMarkedLimit / baggageService.step);
                    intersectionPrice += baggageService.default_price_for_step * stepsOverMarkedLimit;
                }

                return intersectionPrice;
            },
            getBaggageService() {
                return this.baggage_services.find(service => service.id === this.form.baggage_service_id)
            },
            setBaggageAllowanceFromBaggageService(baggageService) {
                const route = this.getSelectedRoute();
                let maxBaggageAllowanceFieldName = 'max_baggage_allowance_local';
                let freeBaggageAllowanceFieldName = 'free_baggage_allowance_local';
                if (route.is_international) {
                    maxBaggageAllowanceFieldName = 'max_baggage_allowance_international';
                    freeBaggageAllowanceFieldName = 'free_baggage_allowance_international';
                }
                this.form.max_baggage_allowance = baggageService[maxBaggageAllowanceFieldName];
                this.form.free_baggage_allowance = baggageService[freeBaggageAllowanceFieldName];
            },
            isTariffSelected() {
                return !_.isEmpty(this.form.tariff_id);
            },
            isBaggageServiceSelected() {
                return this.form.baggage_service_id !== 0 && this.form.baggage_service_id !== null;
            },
            getDepartureTime() {
                let date;
                if (this.departureTimes[0]) {
                    date = new Date(this.departureTimes[0]);
                } else {
                    date = new Date();
                }
                let hour = date.getHours();
                let min = date.getMinutes();
                return (hour < 10 ? "0" + hour : hour) + ":"
                    + (min < 10 ? "0" + min : min)
            },
            setTripPrice() {
                this.price_for_save = [];
                for (let i = 0; i < this.stations.length; i++) {
                    if (i < this.stations.length - 1) {
                        for (let j = 0; j < this.stations.length; j++) {
                            if (j > i) {
                                if (this.schedule_trip_prices[i][j] > 0 && this.schedule_trip_prices[i] != undefined) {
                                    this.price_for_save.push({
                                        from: this.stations[i].station_id,
                                        to: this.stations[j].station_id,
                                        price: parseInt(this.schedule_trip_prices[i][j])
                                    });
                                }
                            }
                        }
                    }
                }
            },
            setTripBaggagePrice() {
                this.baggage_price_for_save = [];
                for (let i = 0; i < this.stations.length; i++) {
                    if (i < this.stations.length - 1) {
                        for (let j = 0; j < this.stations.length; j++) {
                            if (j > i) {
                                if (this.schedule_trip_prices[i][j] > 0 && this.schedule_trip_baggage_prices[i] != undefined) {
                                    this.baggage_price_for_save.push({
                                        from: this.stations[i].station_id,
                                        to: this.stations[j].station_id,
                                        price: parseInt(this.schedule_trip_baggage_prices[i][j])
                                    });
                                }
                            }
                        }
                    }
                }
            },
            handleTimesChanged(arrivalTimes, departureTimes) {
                this.arrivalTimes = arrivalTimes;
                this.departureTimes = departureTimes;
            },
            unsetStation(item) {
                let id = this.stationIds.indexOf(item.id);
                if (id >= 0) {
                    this.stationIds.splice(id, 1);
                } else {
                    this.stationIds.push(item.id);
                }
            },
            save(redirect = false) {
                try {
                    this.is_sending = true;
                    this.form.begin_at = this.$moment(this.form.begin_at).format('Y-MM-DD') + " " + this.getDepartureTime();

                    this.setTripPrice();
                    this.setTripBaggagePrice();
                    this.form.price = (this.schedule_trip_prices[0] != undefined) ? this.schedule_trip_prices[0][this.schedule_trip_prices[0].length - 1] : null;
                    this.form.schedule_trip_prices.price = this.price_for_save;
                    this.form.schedule_trip_baggage_prices.price = this.baggage_price_for_save;

                    if (this.form.schedule_trip_details.slice(-1)[0] != undefined) {
                        this.form.schedule_trip_details.slice(-1)[0].estimated_time_of_departure = 0;
                    }

                    if (this.id) {
                        this.update(redirect);
                    } else {
                        this.create(redirect);
                    }
                } catch (error) {
                    this.is_sending = false;
                    this.$store.commit('errorNotifyByText', error.message);
                }
            },
            create(redirect) {
                this.form.post('schedule-trips.create')
                    .then(res => {
                        if (!res.errors) {
                            if (redirect) {
                                this.$router.push({name: 'schedules'});
                            }
                            this.$store.commit('successNotify');
                        }
                    })
                    .finally(() => {
                        this.is_sending = false;
                    })
            },
            update(redirect) {
                this.form.put('schedule-trips.update', this.id)
                    .then(res => {
                        if (!res.errors) {
                            if (redirect) {
                                this.$router.push({name: 'schedules'});
                            }
                            this.$store.commit('successNotify');
                        }
                    })
                    .finally(() => {
                        this.is_sending = false;
                    })
            },
        },
        computed: {
            departureTime() {
                return this.departureTimes[0]
            },
            arrivalTime() {
                return this.arrivalTimes.slice(-1)[0]
            },
            timeOnWay() {
                return (this.form.schedule_trip_details.slice(-1)[0]
                    || {estimated_time_of_arrival: ''}).estimated_time_of_arrival;
            },
        },
        filters: {
            asTime(val, i18n) {
                let hour = Math.floor(val / 60 / 60);
                let min = Math.floor(val / 60 % 60);
                return hour + ' ' + i18n('h') + ' ' + min + ' ' + i18n('min')
            }
        },
        watch: {
            'form.begin_at': function (val) {
                console.log('watch');
                console.log(val);
            },
            stationIds: function (val) {
                this.stations = this.allStations.filter(item => val.includes(item.id));
                this.calculatePrices();
                this.$forceUpdate();
            },
            'form.tariff_id': function (tariff_id) {
                let baggageService = this.getBaggageService();
                if (!baggageService) {
                    return;
                }
                if (this.form.baggage_price_calculation_type === 1
                        && baggageService.pricing_type === this.baggageServicePricingTypes.TYPE_PERCENT_PRICE) {
                    this.calculateBaggagePrices();
                }
            },
        }
    }
</script>

<style scoped>

</style>
